import React, { useEffect, useState } from 'react'
import FormSubmitButton from 'Common/Custom/FormSubmitButton';
import { HeadingOne } from 'Common/Custom/HeadingOne';
import PageBody from 'Common/Custom/PageBody';
import { GetAllRoomList } from 'adminApi/AssignRoomOfferApi/AssignRoomOffer';
import fields from '../../json/AssignRoomOfferFields.json';
import useFetchAllData from 'Hooks/useFetchAllData';
import FormSelect from 'Common/Custom/FormSelect';
import FormInput from 'Common/Custom/FormInput';
import FormDatePicker from 'Common/Custom/ReactFlatpickr';

const AssignRoomOfferForm = ({ values, errors, handleChange, handleSubmit, loading, title = "Assign Room Offer", setValues }) => {
    const { formdata } = fields;
    const { data: allRooms } = useFetchAllData(GetAllRoomList);

    const [original_rate, setOriginalRate] = useState(0);

    useEffect(() => {
        const rate = values?.room_id
            ? allRooms?.find((room) => room.room_id === values.room_id)?.original_rate
            : null;
        setOriginalRate(rate);
    }, [values?.room_id, allRooms]);

    return (
        <PageBody
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            <div className="alert alert-light border-secondary d-flex justify-content-between align-items-center mb-3">
                <span className="fw-semibold">Original Room Rate:</span>
                <span className="fs-5 fw-bold text-success">₹{original_rate ? original_rate : 0}</span>
            </div>

            {formdata.map((field) => {
                if (field.type === "select") {
                    if (field.name === "room_id") {
                        const options = (allRooms || []).map((opt) => ({
                            value: opt.room_id,
                            label: opt.room_type
                        }));
                        return (
                            <FormSelect
                                key={field.name}
                                field={field}
                                value={values[field.name]}
                                handleChange={handleChange}
                                options={options}
                                error={errors[field.name]}
                            />
                        );
                    }
                }
                if (field.type === "date") {
                    return (
                        <FormDatePicker
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                            mode="date"
                            disablePast={true}
                            yearLimit={{ prev: 0, next: 1 }}
                        />
                    );
                }

                // default text input
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label={title}
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
}

export default AssignRoomOfferForm